import React from 'react'

import { EuiConfirmModal, EuiFieldText, EuiFormRow } from '@elastic/eui'

import { useCreateAccountMutation } from '../../api/rtkQueryApi/platform/accountsApi'
import { isValidURL } from '../../utils/isValidUrl'

export interface IClientCreateModal {
  onCancel: () => void
  onClientCreated: () => void
}

export const ClientCreateModal: React.FC<IClientCreateModal> = props => {
  const [client, setClient] = React.useState<{ name: string; website: string }>({
    name: '',
    website: ''
  })
  const [createAccount, createAccountRequest] = useCreateAccountMutation()

  const onConfirmClick = () => {
    createAccount({
      name: client.name,
      website: client.website
    }).then(() => {
      props.onClientCreated()
    })
  }

  const isValid = client.name.length > 0 && isValidURL(client.website)

  return (
    <EuiConfirmModal title={'New Client'} onConfirm={onConfirmClick} onCancel={props.onCancel} confirmButtonText={'Create'} cancelButtonText={'Cancel'} isLoading={createAccountRequest.isLoading} confirmButtonDisabled={!isValid}>
      <EuiFormRow label={'Client Name'}>
        <EuiFieldText value={client.name} onChange={e => setClient(c => ({ ...c, name: e.target.value }))} />
      </EuiFormRow>
      <EuiFormRow label={'Website URL'}>
        <EuiFieldText value={client.website} onChange={e => setClient(c => ({ ...c, website: e.target.value }))} />
      </EuiFormRow>
    </EuiConfirmModal>
  )
}
